// extracted by mini-css-extract-plugin
module.exports = {"page":"PageButton_page__huSN5","current":"PageButton_current__w9Ixt","ellipsis":"PageButton_ellipsis__hxs7o"};